import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { Heading, Text } from './Typography';

interface ListToolbarProps {
    title?: ReactNode;
    description?: ReactNode;
    search?: ReactNode;
    controls?: ReactNode;
    filters?: ReactNode;
    className?: string;
}

export default function ListToolbar({
    title,
    description,
    search,
    controls,
    filters,
    className,
}: ListToolbarProps) {
    const hasHeading = Boolean(title || description);

    return (
        <div className={cn('flex flex-col gap-5', className)}>
            {(title || description || search || controls) && (
                <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                    {hasHeading && (
                        <div className="space-y-1.5">
                            {title && (
                                <Heading as="h2" variant="section">
                                    {title}
                                </Heading>
                            )}
                            {description && <Text variant="description">{description}</Text>}
                        </div>
                    )}
                    {(search || controls) && (
                        <div
                            className={cn(
                                'flex w-full flex-col gap-3 sm:flex-row sm:items-center',
                                hasHeading ? 'lg:w-auto' : 'lg:w-full lg:justify-end',
                            )}
                        >
                            {search}
                            {controls}
                        </div>
                    )}
                </div>
            )}
            {filters && <div className="flex flex-wrap gap-2">{filters}</div>}
        </div>
    );
}
